
import { useCallback } from 'react';
import { initializeOpenAIClient } from '@/lib/openai';
import { useToast } from '@/hooks/use-toast';

export const useOpenAIClient = () => {
  const { toast } = useToast();

  const initializeOpenAI = useCallback(async () => {
    try {
      console.log('Initializing OpenAI...');
      const client = await initializeOpenAIClient();
      return client;
    } catch (error) {
      console.error('Error initializing OpenAI:', error);
      toast({
        title: "Error",
        description: "No se pudo inicializar el asistente de voz. Por favor, intente más tarde.",
        variant: "destructive"
      });
      return null;
    }
  }, [toast]);

  return {
    initializeOpenAI
  };
};
